import { Toaster } from "@/components/ui/sonner";
import { MetaProvider, Title } from "@solidjs/meta";
import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import LoaderCircleIcon from "lucide-solid/icons/loader-circle";
import { Suspense, lazy } from "solid-js";
import { AppErrorBoundary } from "./components/core/error-boundary";
import { ThemeProvider } from "./components/core/theme";

import Footer from "@/components/core/footer";
import Header from "@/components/core/header";

import "./app.css";
import "./styles/ticketbud.css";

const TailwindIndicator = lazy(() => import("@/components/dev/tw-indicator"));

export default function App() {
  return (
    <AppErrorBoundary>
      <ThemeProvider>
        <Router
          root={(props) => (
            <MetaProvider>
              <Title>Positive Traction</Title>
              <div class="flex flex-1 flex-col items-center">
                <Header />
                <Suspense fallback={<LoaderCircleIcon class="animate-spin" />}>
                  <div class="flex w-full grow flex-col scroll-smooth">
                    {props.children}
                  </div>
                  <TailwindIndicator />
                </Suspense>
                <Footer />
              </div>
            </MetaProvider>
          )}
        >
          <FileRoutes />
        </Router>
        <Toaster />
      </ThemeProvider>
    </AppErrorBoundary>
  );
}
